module.exports = __webpack_public_path__ + "img/2.4b50abd2.jpg";